import { configureStore } from '@reduxjs/toolkit';
import authReducer from '@/features/auth/store/authSlice';
import coreReducer from './slices/Core';
import authApi from '@/features/auth/api/authApi';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    core: coreReducer,
    socket: coreReducer, // Using core reducer for socket state
    [authApi.reducerPath]: authApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(authApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

